<!--
  Tarjeta de tasas del home.

  Una fila por producto con el par de banderas, el nombre y, cuando la tasa
  depende del monto, la tasa del primer tramo, «Mejor X desde Y» y una mini
  escalera. Tocar esa fila abre (uno
  a la vez) un simulador de monto LOCAL y la escalera de tramos compartida
  (`app-escalera-tramos`). El monto del simulador nunca viaja: el botón abre el
  cotizador sin monto, como siempre.
-->
<section class="hr" *ngIf="estado$ | async as st">

  <button
    type="button"
    class="hr__head"
    (click)="toggleTarjeta()"
    [attr.aria-expanded]="!colapsada"
    aria-controls="hr-body"
  >
    <span class="hr__head-icon">
      <mat-icon>trending_up</mat-icon>
    </span>
    <span class="hr__head-text">
      <span class="hr__head-title">Tasas del Día</span>
    </span>
    <mat-icon class="hr__chev" [class.hr__chev--cerrado]="colapsada">
      expand_more
    </mat-icon>
  </button>

  <div id="hr-body" *ngIf="!colapsada">

    <div class="hr__cargando" *ngIf="!st.nivel1.length">
      <mat-spinner diameter="20"></mat-spinner>
      <span>Buscando las tasas del día…</span>
    </div>

    <!-- Enviar dinero: el riel propio -->
    <ng-container *ngIf="vista.envios.length">
      <div class="hr__grupo">Enviar dinero</div>
      <ng-container *ngFor="let p of vista.envios; trackBy: trackProducto">
        <ng-container *ngTemplateOutlet="producto; context: { $implicit: p }"></ng-container>
      </ng-container>
    </ng-container>

    <!-- USDT -->
    <ng-container *ngIf="vista.usdt.length">
      <div class="hr__grupo">USDT</div>
      <ng-container *ngFor="let p of vista.usdt; trackBy: trackProducto">
        <ng-container *ngTemplateOutlet="producto; context: { $implicit: p }"></ng-container>
      </ng-container>
    </ng-container>

    <!-- Otros destinos, plegados -->
    <details class="hr__otros" *ngIf="vista.otros.length">
      <summary>
        <span>Otros destinos ({{ vista.otros.length }})</span>
        <span class="hr__chev-css" aria-hidden="true"></span>
      </summary>
      <ng-container *ngFor="let p of vista.otros; trackBy: trackProducto">
        <ng-container *ngTemplateOutlet="simple; context: { $implicit: p }"></ng-container>
      </ng-container>
    </details>
  </div>
</section>

<!-- Un producto: con escalera (acordeón), par como hoy o un solo número. -->
<ng-template #producto let-p>
  <ng-container *ngIf="p.escalera; else sinEscalera">
    <div class="hr__item">
      <button
        type="button"
        class="hr__fila hr__fila--acc"
        (click)="toggleProducto(p)"
        [attr.aria-expanded]="abierto === p.id"
        [attr.aria-controls]="domId(p) + '-det'"
      >
        <span class="hr__par" aria-hidden="true">
          <img class="hr__ic" [src]="p.iconoOrigen" alt="" />
          <img class="hr__ic hr__ic--dst" [src]="p.iconoDestino" alt="" />
        </span>

        <span class="hr__nombre">
          <span class="hr__nombre-fuerte">{{ p.nombre }}</span>
          <span class="hr__sub">
            <span class="hr__mini" aria-hidden="true">
              <i
                *ngFor="let e of p.escalera; let k = index; trackBy: trackEscalon"
                [class.on]="e.mejor"
                [style.height.px]="alturaMini(k, p.escalera.length)"
              ></i>
            </span>
            <span>{{ p.unidad }} · {{ p.escalera.length }} {{ p.escalera.length === 1 ? 'tramo' : 'tramos' }}</span>
          </span>
          <span class="hr__mejor" *ngIf="mejor(p) as m">{{ m }}</span>
        </span>

        <span class="hr__resumen" [class.hr__resumen--vieja]="p.fila.vieja">
          <b>{{ desde(p) }}</b>
          <span>{{ p.simbolo }}</span>
        </span>

        <span class="hr__chev-css" [class.hr__chev-css--abierto]="abierto === p.id" aria-hidden="true"></span>
      </button>

      <div class="hr__det" *ngIf="abierto === p.id" [id]="domId(p) + '-det'">
        <div>
          <label class="hr__lbl" [for]="domId(p) + '-in'">{{ p.verbo }}</label>
          <div class="hr__inp">
            <span>{{ prefijo(p) }}</span>
            <input
              [id]="domId(p) + '-in'"
              type="text"
              inputmode="decimal"
              autocomplete="off"
              placeholder="0"
              [value]="montoTexto[p.id] || ''"
              (input)="alEscribir(p, $any($event.target).value)"
              (blur)="alSalir(p)"
              [attr.aria-describedby]="domId(p) + '-tu'"
            />
          </div>
          <div class="hr__chips" role="group" aria-label="Montos típicos" *ngIf="p.montosTipicos.length">
            <button
              type="button"
              *ngFor="let v of p.montosTipicos"
              [attr.aria-pressed]="monto(p) === v"
              (click)="elegirMonto(p, v)"
            >
              {{ chip(p, v) }}
            </button>
          </div>
        </div>

        <app-escalera-tramos
          [escalera]="p.escalera"
          [monto]="monto(p)"
          [moneda]="p.monedaMonto"
          [monedaDestino]="p.monedaDestino"
          [tipoAhorro]="p.tipoAhorro"
          [decimales]="p.decimales"
          [base]="p.base"
          [precioCorte]="p.precioCorte"
          [simbolo]="p.simbolo"
          [unidad]="p.unidad"
          [idBase]="domId(p)"
        ></app-escalera-tramos>

        <button type="button" class="hr__cta" *ngIf="navegable(p.fila)" (click)="abrir(p.fila)">
          {{ p.accion }}
        </button>
      </div>
    </div>
  </ng-container>

  <ng-template #sinEscalera>
    <ng-container *ngIf="esParComoHoy(p); else simpleDentro">
      <ng-container *ngTemplateOutlet="par; context: { $implicit: p.fila }"></ng-container>
    </ng-container>
    <ng-template #simpleDentro>
      <ng-container *ngTemplateOutlet="simple; context: { $implicit: p }"></ng-container>
    </ng-template>
  </ng-template>
</ng-template>

<!-- Un producto sin tramos: un solo número con su unidad. -->
<ng-template #simple let-p>
  <div class="hr__item">
    <button
      type="button"
      class="hr__fila"
      [class.hr__fila--link]="navegable(p.fila)"
      [disabled]="!navegable(p.fila)"
      (click)="abrir(p.fila)"
    >
      <span class="hr__par" aria-hidden="true">
        <img class="hr__ic" [src]="p.iconoOrigen" alt="" />
        <img class="hr__ic hr__ic--dst" [src]="p.iconoDestino" alt="" />
      </span>

      <span class="hr__nombre">
        <span class="hr__nombre-fuerte hr__nombre-fuerte--simple">{{ p.nombre }}</span>
      </span>

      <span class="hr__tasa" [class.hr__tasa--vieja]="p.fila.vieja">
        <span class="hr__valor" *ngIf="p.tasa != null">
          {{ valor(p) }}&nbsp;<span class="hr__moneda">{{ p.simbolo }}</span>
        </span>
        <span class="hr__valor hr__valor--vacio" *ngIf="p.tasa == null">—</span>
        <span class="hr__por">{{ p.fila.def.porLabel }}</span>
      </span>
    </button>
  </div>
</ng-template>

<!--
  Fila de par sin tramos: exactamente como hasta hoy.

  OJO con los rótulos. `tasa` sale de la fuente «compra» y es el precio al
  que el cliente COMPRA; `venta`, el precio al que VENDE. Lo prueban las
  pantallas que usan cada endpoint: «Comprar USDT» (calculator-cryto) y
  VES→USDT toman la compra; USDT→CLP y USDT→VES, la venta. Comprar sale
  siempre más caro que vender. (Un comentario anterior decía lo contrario
  y la tarjeta mostró los rótulos cruzados hasta el 27-sep-2026.)
-->
<ng-template #par let-t>
  <div class="hr__item">
    <button
      type="button"
      class="hr__fila"
      [class.hr__fila--link]="navegable(t)"
      [disabled]="!navegable(t)"
      (click)="abrir(t)"
    >
      <span class="hr__par" aria-hidden="true">
        <img class="hr__ic" [src]="t.def.iconoOrigen" alt="" />
        <img class="hr__ic hr__ic--dst" [src]="t.def.iconoDestino" alt="" />
      </span>

      <span class="hr__nombre">
        <span class="hr__nombre-txt">{{ t.def.nombre }}</span>
        <span class="hr__nota">{{ t.def.simbolo }} {{ t.def.porLabel }}</span>
      </span>
    </button>

    <div class="hr__tramos hr__tramos--par" [class.hr__tramos--vieja]="t.vieja">
      <div class="hr__tramo">
        <span class="hr__tramo-desde">Compras a</span>
        <span class="hr__tramo-tasa">
          {{ numeroPar(t.tasa, t) }}
        </span>
        <span class="hr__tramo-moneda">{{ t.def.simbolo }}</span>
      </div>
      <div class="hr__tramo">
        <span class="hr__tramo-desde">Vendes a</span>
        <span class="hr__tramo-tasa">
          {{ numeroPar(t.venta, t) }}
        </span>
        <span class="hr__tramo-moneda">{{ t.def.simbolo }}</span>
      </div>
    </div>
  </div>
</ng-template>
